import {
  FilterValue,
  MultiSelectFilter,
  SelectOption,
  StringArrayFilterValue,
} from "../../types/filter";
import {
  getSelectedFilterValue,
  updatedFilterValueFromValues,
} from "../../utils/filter/filtervalue";
import { createFilterValueFromMultiSelectOption } from "../../utils/filter/selectfiltervalue";
import { MultiSelectListView } from "../SelectListView/MultiSelectListView";

interface FilterTabMultiSelectProps {
  filter: MultiSelectFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
}

export const FilterTabMultiSelect = ({
  filter,
  filterValues,
  setFilterValues,
}: FilterTabMultiSelectProps) => {
  const { id, defaultValue } = filter;
  const selected = getSelectedFilterValue(
    id,
    filterValues,
    defaultValue
  ) as StringArrayFilterValue;
  const handleOnChange = (option: SelectOption, isSelected: boolean) => {
    const value = createFilterValueFromMultiSelectOption(
      id,
      option,
      selected,
      isSelected
    );
    setFilterValues(updatedFilterValueFromValues(filterValues, filter, value));
  };
  return (
    <MultiSelectListView
      prefix="pill"
      filter={filter}
      selected={selected}
      onChange={handleOnChange}
    />
  );
};
